import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';
import { assertNever } from '../../utils/assertNever';
import { resolvePath } from '../../utils/resolvePath';

const enMedicalDeviceText = 'Medical Device';

export const MedicalDevice: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t } = useTranslation(region);

  switch (region) {
    case 'us':
      return null;
    case 'eu': {
      const medicalDeviceText = t('about.medicalDeviceText');
      const showMedicalDeviceTranslation =
        medicalDeviceText.toLocaleLowerCase() !== enMedicalDeviceText.toLocaleLowerCase();
      return (
        <div className='container'>
          <img className='md' src={resolvePath('MD.jpg')} />
          <div className='md-text'>
            {enMedicalDeviceText} {showMedicalDeviceTranslation && `(${medicalDeviceText})`}
          </div>
        </div>
      );
    }
    default:
      assertNever(region);
  }
};
